import { logoPartnerList } from 'constants/logoPartner';
import styles from './footer.style';
import globalStyle from 'constants/global.style';
import { useNavigate } from 'react-router-dom';
import { appName } from 'config/app.config';

function Footer() {
    const navigate = useNavigate();

    return (
        <div className={styles.wrap}>
            <div className={globalStyle.container}>
                {/* <h6 className={styles.heading}>Nhà Cung Cấp</h6> */}
                <p className={styles.footertxt}>Cờ bạc có thể gây nghiện, hãy chơi có trách nhiệm. Để biết thông tin về các biện pháp hỗ trợ, vui lòng truy cập trang trợ giúp của chúng tôi.</p>
                <p className={styles.footertxt}>
                    Chúng tôi được cấp giấy phép hợp pháp do Ủy ban Giám sát GC（GamblingCommission của Vương quốc Anh (MGA). <br></br> Công ty đăng ký tại Quần đảo Virgin thuộc Anh, được các hiệp hội
                    quốc tế công nhận. Vui lòng đảm bảo bạn đủ 18 tuổi trở lên trước khi đăng ký tham gia trò chơi!
                </p>
                <div className={styles.partnerList}>
                    {logoPartnerList.map((item, index) => (
                        <div className={styles.partnerItem} key={index}>
                            <img src={item} alt="" />
                        </div>
                    ))}
                </div>
            </div>
            <div className={globalStyle.container}>
                <div className={styles.about}>
                    <div className={styles.aboutItem} onClick={() => navigate('/help?view=1')}>
                        Quy Định Luật Lệ
                    </div>
                    <div className={styles.aboutItem} onClick={() => navigate('/help?view=2')}>
                        Trách Nhiệm Người Chơi
                    </div>
                    <div className={styles.aboutItem} onClick={() => navigate('/help?view=3')}>
                        Chính Sách Bảo Mật
                    </div>
                    <div className={styles.aboutItem} onClick={() => navigate('/help?view=4')}>
                        Tuyên Bố Bản Quyền
                    </div>
                    <div className={styles.aboutItem} onClick={() => navigate('/help?view=5')}>
                        Hướng Dẫn
                    </div>
                    <div className={styles.aboutItem} onClick={() => window.open('https://daily.188lux.vip', '_blank')}>
                        Hợp tác đại lý
                    </div>
                </div>
            </div>
            <p className={styles.lisence}>© 2023 bản quyền thuộc {appName}</p>
        </div>
    );
}

interface TitleSectionProps {
    title: string;
    icon: string;
    hideShowAll?: boolean;
    onShowAll?: () => void;
}

const TitleSection = (props: TitleSectionProps) => {
    const { title } = props;

    return (
        <div className={styles.title}>
            <div className="d-flex align-items-center title-game">
                <h6>{title}</h6>
            </div>
        </div>
    );
};

export default Footer;
